/**
 * AccentBorderCard — Polaris Card with a coloured left border.
 *
 * Used for feature highlight cards (onboarding, dashboard quick-wins).
 *
 * @see documents/ui-enhancement-spec.md §10.1
 */

import React from 'react';
import { Card } from '@shopify/polaris';

interface AccentBorderCardProps {
  children: React.ReactNode;
  /** Border colour — defaults to accent token */
  borderColor?: string;
  /** Border width in px (default: 3) */
  borderWidth?: number;
}

export function AccentBorderCard({
  children,
  borderColor = 'var(--z-accent)',
  borderWidth = 3,
}: AccentBorderCardProps): React.ReactElement {
  return (
    <div
      style={{
        borderLeft: `${borderWidth}px solid ${borderColor}`,
        borderRadius: 'var(--p-border-radius-200)',
        overflow: 'hidden',
      }}
    >
      <Card>{children}</Card>
    </div>
  );
}
